import React from 'react';
import block from 'bem-cn-lite';

import {FormProps} from 'units/constructor-local/models';
import YandexForm from 'components/YandexForm/YandexForm';

import './Form.scss';

const b = block('form-block-deprecated');

const Form: React.FunctionComponent<FormProps> = ({id, metrikaGoals, border}) => (
    <div className={b({border})}>
        <YandexForm id={id} metrikaGoals={metrikaGoals} className={b('form-wrapper', {border})} />
    </div>
);

export default Form;
